<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="custom-greater-than-icon">
    <path d="M5 8l5 5 5-5" />
  </svg>
</template>

<script>
export default {
  name: 'CustomGreaterThanIcon',
};
</script>

<style scoped>
.custom-greater-than-icon {
  /* 自定义样式 */
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/RightIcon.vue